import type { NeedsAttentionRider } from '../../../types/skills';

interface NeedsAttentionCalloutProps {
  riders: NeedsAttentionRider[];
  onRiderSelect: (riderId: string) => void;
}

/**
 * Prominent callout listing riders who need coaching attention.
 * Hidden when no riders meet the criteria.
 *
 * Requirements: 8.1, 8.2, 8.3, 8.4, 8.5, 11.6, 12.1, 12.3, 12.4
 */
export default function NeedsAttentionCallout({ riders, onRiderSelect }: NeedsAttentionCalloutProps) {
  if (riders.length === 0) return null;

  return (
    <div className="rounded-lg border border-amber-300 bg-amber-50 p-4">
      <h3 className="mb-2 text-base font-semibold text-amber-800">
        ⚠️ Needs Attention ({riders.length})
      </h3>
      <ul className="space-y-1">
        {riders.map((rider) => (
          <li key={rider.rider_id} className="flex flex-col gap-0.5">
            <button
              type="button"
              onClick={() => onRiderSelect(rider.rider_id)}
              className="min-h-[44px] min-w-[44px] self-start text-left text-base font-medium text-amber-900 underline hover:text-amber-700 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-1 rounded"
            >
              {rider.name}
            </button>
            <span className="text-sm text-amber-700">{rider.reason}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
